<template>
    <div id="portal-content" ref="portalContent">
        <resize-observer @notify="handleResize"></resize-observer>
        <b-alert v-if="portal && !portal.published" show variant="warning" class="mb-0">
            <b-icon icon="exclamation-triangle-fill" variant="warning" class="mr-1"></b-icon>This portal is a draft (unpublished)</b-alert>
        <PortalHeader v-if="portal && !portal.header && !portal.iframe" :portal="portal"/>
        <div id="header" v-if="portal && portal.header" v-html="portal.header"/>

        <router-view v-if="portal || error" :portal="portal" :published="published"/>

        <PortalFooter v-if="!portal || !portal.footer"/>
        <div id="footer" v-if="portal && portal.footer" v-html="portal.footer"/>
    </div>
</template>

<script>
    import SubmissionService from "@/services/SubmissionService";
    import PortalHeader from "@/components/portal/submission/PortalHeader";
    import PortalFooter from "@/components/portal/submission/PortalFooter";

    export default {
        name: "Portal",
        created() {
            document.title = "Portal";
        },
        components: {
            PortalHeader,
            PortalFooter,
        },
        data() {
            return {
                portal: null,
                error: false,
                published: true
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('load', this.handleResize);
        },
        mounted() {
            this.getPortalConf(this.$route.params.name);
        },
        methods: {
            handleResize() {
                let clientHeight = document.getElementById('portal-content').scrollHeight;
                parent.postMessage("resize::" + clientHeight, "*");
            },
            getPortalConf(name) {
                this.published = this.$route.name !== 'DraftSubmission' && this.$route.name !== 'DraftConfirmation' && this.$route.name !== 'DraftError';
                SubmissionService.initPortal(name, this.published)
                    .then(response => {
                        this.portal = response.data;
                        if (this.portal.title) {
                            document.title = this.portal.title;
                        } else {
                            document.title = this.portal.name;
                        }
                        if (this.portal.faviconUrl) {
                            var favicon = document.getElementById('favicon');
                            favicon.href = this.portal.faviconUrl;
                        }
                        this.getStyle(this.portal);
                    })
                    .catch(error => {
                        this.error = true;
                        switch (error.response.status) {
                            case 404: {
                                this.$router.push({
                                    name: 'PortalError',
                                    params: {
                                        portal: this.portal,
                                        errorStatusCode: error.response.status,
                                        errorStatusText: error.response.statusText,
                                        errorMessage: "Portal with name " + name.toUpperCase() + " not found."
                                    }
                                })
                                break;
                            }
                            case 503: {
                                this.$router.push({
                                    name: 'PortalError',
                                    params: {
                                        portal: this.portal,
                                        errorStatusCode: error.response.status,
                                        errorStatusText: error.response.statusText,
                                        errorMessage: "Portal with name " + name.toUpperCase() + " is unavailable.",
                                        customError: error.response.data
                                    }
                                })
                                break;
                            }
                            default: {
                                this.$router.push({
                                    name: 'PortalError', params: {
                                        portal: this.portal,
                                        errorMessage: error
                                    }
                                })
                                break;
                            }
                        }
                    })
            },
            getStyle(portal) {
                let style = document.createElement('style')
                style.type = "text/css"
                style.appendChild(document.createTextNode(portal.style))
                document.head.appendChild(style)
            },
        },
    }
</script>

<style>
    body {
        background: #eae9e7;
        font-family: HelveticaNeueLight, Arial, Helvetica, sans-serif;
    }

    th.required div::after,
    .required label::after {
        content: none;
    }

    .required > label::after,
    .ckc-required > label > span::after {
        content: " *";
        color: red;
    }

    #portal-content {
        position: relative;
    }

    #conf-nav {
        display: none;
    }
</style>